import type { ItemGrid, SlotDragData } from './ItemGrid';
import type { GridTransferRule } from './types';

/**
 * Wires multiple ItemGrids together according to a set of transfer rules.
 * Only transfers between grids where a matching rule exists are allowed.
 * Drops onto occupied slots are silently ignored (ItemGrid only fires onDrop
 * for empty slots, so this is enforced at the grid level).
 */
export class GridDragDrop {
  private readonly grids = new Map<string, ItemGrid>();
  private readonly rules: GridTransferRule[];

  constructor(rules: GridTransferRule[]) {
    this.rules = rules;
  }

  public register(grid: ItemGrid): void {
    this.grids.set(grid.gridId, grid);
    grid.onDrop = (targetSlotId: string, data: SlotDragData) => {
      const rule = this.rules.find(
        (r) => r.from === data.gridId && r.to === grid.gridId
      );
      if (!rule) return;
      rule.onTransfer(data.slotId, targetSlotId);
    };
  }
}
